<!-- <p>analytics works!</p> -->
<!-- <app-bread-crumb></app-bread-crumb> -->
<div class="analytics-router"><router-outlet></router-outlet></div>
